<template>
  <div>
    <div class="container mx-auto">
      <form v-on:keyup.enter="search()" v-on:submit.prevent>
        <div class="flex flex-row py-4 gap-10">
          <multi-select
              class="w-4"
              :options="dzoList"
              :selected-options="selectedDzoOptions"
              v-model="dzo"
              placeholder="ДЗО"
              @select="onSelect"
              :hideSelectedOptions=true
              v-if="accessLevel(USER.ouser.role, 3)"
          ></multi-select>
          <model-select
              :options="years"
              v-model="year"
              placeholder="Год"
          ></model-select>
          <model-select
              :options="months"
              v-model="month"
              :isDisabled="quarterPresent"
              placeholder="Месяц"
          ></model-select>

          <model-select
              :options="quartersOptions"
              v-model="quarter"
              :isDisabled="monthPresent"
              placeholder="Квартал, полугодие"
          ></model-select>

          <button
              class="transition-all ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white"
              @click="search()"
              id="v-step-3"
          >
            Поиск
          </button>
          <button
              class="transition-all ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white"
              @click="clear()"
          >
            Очистить
          </button>
          <button
              class="transition-all ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white"
              @click="download()"
          >
            Скачать
          </button>
        </div>
      </form>

      <div v-show="showSelectedDzo">
        Выбранные ДЗО
        <ul v-for="(selectedDzo, index) in selectedDzoOptions" :key="selectedDzo.value">
          <li>{{ ++index + ' - ' + selectedDzo.text }}</li>
        </ul>
      </div>


      <div class="flex flex-col">
        <div class="overflow-x-auto container mx-auto">
          <div class="py-2 inline-block">
            <div class="overflow-hidden">
              <table
                  class="table-auto text-base border border-collapse text-center"
              >
                <caption
                    class="text-lg font-bold text-left my-2"
                >
                  1. Информация по движению востребованных ТМЗ
                </caption>
                <thead class="border-b bg-gray-50">
                <tr>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r"
                      rowspan="2"
                  >
                    <div class="tooltip">
                      Оборачиваемость в днях
                      <span class="tooltiptext">Примечание: Оборачиваемость=((остаток на начало отчетного года (за исключение аварийно страхового запаса за декбарь) + остаток на конец отчетного периода-аварийно страховой запас на конец отчетного периода)/2/использовано в производстве(сумма с января по текущий месяц)*365 (кол-во дней в отчетном периоде)</span>
                    </div>
                  </th>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r"
                      rowspan="2"
                  >
                    Остатки за предыдущие фин.годы
                  </th>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r"
                      rowspan="2"
                  >
                    Утвержденный годовой бюджет ТМЗ на
                    финансовый {{ year }} год
                  </th>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r"
                      colspan="2"
                  >
                    Поступило ТМЗ
                  </th>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r"
                      colspan="2"
                  >
                    Использовано в производстве
                  </th>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r"
                      colspan="2"
                  >
                    Переведено в НВЛ
                  </th>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r"
                      colspan="2"
                  >
                    Переведено в НЛ
                  </th>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r"
                      colspan="2"
                  >
                    Остаток на конец отчетного месяца
                  </th>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r"
                      rowspan="2"
                  >
                    Итого остаток
                  </th>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2"

                  >
                    Аварийный запас <br>
                    Страховой запас
                  </th>
                </tr>
                <tr>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r border-t"
                  >
                    Поступлени по переходящим договорам
                  </th>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r border-t"
                  >
                    {{ year }} год
                  </th>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r border-t"
                  >
                    Из остатков за предыдущие фин.годы
                  </th>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r border-t"
                  >
                    Из остатков образовав. в текущем году
                  </th>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r border-t"
                  >
                    Из остатков за предыдущие фин.годы
                  </th>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r border-t"
                  >
                    Из остатков образовав. в текущем году
                  </th>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r border-t"
                  >
                    Из остатков за предыдущие фин.годы
                  </th>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r border-t"
                  >
                    Из остатков образовав. в текущем году
                  </th>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r border-t"
                  >
                    Остатки за предыдущие фин.годы
                  </th>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r border-t"
                  >
                    {{ year }} год
                  </th>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r border-t"
                  >
                    Сумма
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td
                      class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r"
                  >
                    <loader v-if="isLoading" />
                    <span v-else>{{ turnoverDays }}</span>
                  </td>
                  <td
                      class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r"
                  >
                    {{
                      this.tableData
                          ? this.tableData[0]
                              .total_remains_before_tmz_sum
                          : 0 | getNumberFormat
                    }}
                  </td>
                  <td
                      class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r"
                  >
                    {{
                      this.tableData
                          ? this.tableData[0]
                              .total_approved_budget_sum
                          : 0 | getNumberFormat
                    }}
                  </td>
                  <td
                      class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r"
                  >
                    {{
                      this.tableData
                          ? this.tableData[0]
                              .total_come_tmc_sum_old
                          : 0 | getNumberFormat
                    }}
                  </td>
                  <td
                      class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r"
                  >
                    {{
                      this.tableData
                          ? this.tableData[0]
                              .total_come_tmc_sum
                          : 0 | getNumberFormat
                    }}
                  </td>
                  <td
                      class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r"
                  >
                    {{
                      this.tableData
                          ? this.tableData[0]
                              .total_used_production_sum_old
                          : 0 | getNumberFormat
                    }}
                  </td>
                  <td
                      class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r"
                  >
                    {{
                      this.tableData
                          ? this.tableData[0]
                              .total_used_production_sum
                          : 0 | getNumberFormat
                    }}
                  </td>
                  <td
                      class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r"
                  >
                    {{
                      this.tableData
                          ? this.tableData[0]
                              .total_to_transferred_nvl_sum_old
                          : 0 | getNumberFormat
                    }}
                  </td>
                  <td
                      class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r"
                  >
                    {{
                      this.tableData
                          ? this.tableData[0]
                              .total_to_transferred_nvl_sum
                          : 0 | getNumberFormat
                    }}
                  </td>
                  <td
                      class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r"
                  >
                    {{
                      this.tableData
                          ? this.tableData[0]
                              .total_to_transferred_liquid_sum_old
                          : 0 | getNumberFormat
                    }}
                  </td>
                  <td
                      class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r"
                  >
                    {{
                      this.tableData
                          ? this.tableData[0]
                              .total_to_transferred_liquid_sum
                          : 0 | getNumberFormat
                    }}
                  </td>
                  <td
                      class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r"
                  >
                    {{
                      this.tableData
                          ? this.tableData[0]
                              .total_remains_after_tmz_sum_old
                          : 0 | getNumberFormat
                    }}
                  </td>
                  <td
                      class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r"
                  >
                    {{
                      this.tableData
                          ? this.tableData[0]
                              .total_remains_after_tmz_sum
                          : 0 | getNumberFormat
                    }}
                  </td>
                  <td
                      class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r"
                  >
                    {{
                      this.tableData
                          ? this.tableData[0]
                              .t_total_sum
                          : 0 | getNumberFormat
                    }}
                  </td>
                  <td
                      class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap"
                  >
                    {{
                      this.tableData
                          ? this.tableData[0]
                              .t_energy_stock_sum
                          : 0 | getNumberFormat
                    }}
                  </td>
                </tr>
                </tbody>
              </table>

              <table
                  class="table-auto w-full text-base border border-collapse text-center mt-4"
              >
                <caption
                    class="text-lg font-bold text-left my-2"
                >
                  2. Информация по движению невостребованных
                  ликвидных ТМЗ
                </caption>
                <thead class="border-b bg-gray-50">
                <tr>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r"
                  >
                    Остатки за предыдущие фин.годы
                  </th>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r"
                  >
                    Поступило ТМЗ
                  </th>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r"
                  >
                    Реализовано ТМЗ
                  </th>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r"
                  >
                    Переведено ТМЗ в востребованные
                  </th>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r"
                  >
                    Переведено в НЛ
                  </th>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r"
                  >
                    Остаток на конец отчетного месяца
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td
                      class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r"
                  >
                    {{
                      this.tableData
                          ? this.tableData[1]
                              .total_remains_before_tmz_sum
                          : 0 | getNumberFormat
                    }}
                  </td>
                  <td
                      class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r"
                  >
                    {{
                      this.tableData
                          ? this.tableData[1]
                              .total_come_tmc_sum
                          : 0 | getNumberFormat
                    }}
                  </td>
                  <td
                      class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r"
                  >
                    {{
                      this.tableData
                          ? this.tableData[1]
                              .total_implemented_tmc_sum
                          : 0 | getNumberFormat
                    }}
                  </td>
                  <td
                      class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r"
                  >
                    {{
                      this.tableData
                          ? this.tableData[1]
                              .total_transferred_vl_tmc_sum
                          : 0 | getNumberFormat
                    }}
                  </td>
                  <td
                      class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r"
                  >
                    {{
                      this.tableData
                          ? this.tableData[1]
                              .total_transferred_illiquid_tmc_sum
                          : 0 | getNumberFormat
                    }}
                  </td>
                  <td
                      class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r"
                  >
                    {{
                      this.tableData
                          ? this.tableData[1]
                              .total_remains_after_tmz_sum
                          : 0 | getNumberFormat
                    }}
                  </td>
                </tr>
                </tbody>
              </table>

              <table
                  class="table-auto w-full text-base border border-collapse text-center mt-4"
              >
                <caption
                    class="text-lg font-bold text-left my-2"
                >
                  3. Информация по движению неликвидных ТМЗ
                </caption>
                <thead class="border-b bg-gray-50">
                <tr>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r"
                  >
                    Остатки за предыдущие фин.годы
                  </th>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r"
                  >
                    Поступило ТМЗ
                  </th>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r"
                  >
                    Реализовано
                  </th>
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r"
                  >
                    Переведено в категорию металлолом
                  </th>
                  <!-- <th
                    class="text-sm font-medium text-gray-900 px-6 py-2 border-r"
                  >
                    Переведено в категорию утилизирован
                  </th> -->
                  <th
                      class="text-sm font-medium text-gray-900 px-6 py-2 border-r"
                  >
                    Остаток на конец отчетного месяца
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td
                      class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r"
                  >
                    {{
                      this.tableData
                          ? this.tableData[2]
                              .total_remains_before_tmz_sum
                          : 0 | getNumberFormat
                    }}
                  </td>
                  <td
                      class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r"
                  >
                    {{
                      this.tableData
                          ? this.tableData[2]
                              .total_come_tmc_sum
                          : 0 | getNumberFormat
                    }}
                  </td>
                  <td
                      class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r"
                  >
                    {{
                      this.tableData
                          ? this.tableData[2]
                              .total_implemented_tmc_sum
                          : 0 | getNumberFormat
                    }}
                  </td>
                  <td
                      class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r"
                  >
                    {{
                      this.tableData
                          ? this.tableData[2]
                              .total_transferred_to_metal_sum
                          : 0 | getNumberFormat
                    }}
                  </td>
                  <!-- <td
                    class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r"
                  >
                    {{
                      this.tableData
                        ? this.tableData[2]
                            .total_transferred_to_util_sum
                        : 0 | getNumberFormat
                    }}
                  </td> -->
                  <td
                      class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r"
                  >
                    {{
                      this.tableData
                          ? this.tableData[2]
                              .total_remains_after_tmz_sum
                          : 0 | getNumberFormat
                    }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { ModelSelect, MultiSelect } from 'vue-search-select';
import axios from 'axios';
import store from '@/store';
import NProgress from 'nprogress';
import Loader from "../../components/loader/Loader"
export default {
  components: {
    ModelSelect,
    MultiSelect,
    Loader
  },
  data() {
    return {
      dzo: '',
      year: '',
      month: '',
      quarter: '',
      years: [
        { value: 2021, text: '2021' },
        { value: 2022, text: '2022' },
        { value: 2023, text: '2023' },
        { value: 2024, text: '2024' },
        { value: 2025, text: '2025' },
        { value: 2026, text: '2026' },
      ],
      months: [
        { value: 1, text: 'Январь' },
        { value: 2, text: 'Февраль' },
        { value: 3, text: 'Март' },
        { value: 4, text: 'Апрель' },
        { value: 5, text: 'Май' },
        { value: 6, text: 'Июнь' },
        { value: 7, text: 'Июль' },
        { value: 8, text: 'Август' },
        { value: 9, text: 'Сентябрь' },
        { value: 10, text: 'Октябрь' },
        { value: 11, text: 'Ноябрь' },
        { value: 12, text: 'Декабрь' },
      ],
      quartersOptions: [
        { value: 41, text: 'I квартал' },
        { value: 42, text: 'II квартал' },
        { value: 43, text: 'III квартал' },
        { value: 44, text: 'IV квартал' },
        { value: 61, text: 'I полугодие' },
        { value: 62, text: 'II полугодие' },
        { value: 100, text: 'Годовой' },
      ],
      tableData: undefined,
      selectedDzoOptions: [],
      showSelectedDzo: false,
      turnoverDays: '',
      isLoading: false
    };
  },
  watch: {
    year: function (val) {
      this.$emit('yearChanged', val)
    }
  },
  methods: {
    search() {

      if (this.selectedDzoOptions.length > 0) {
        if (this.selectedDzoOptions.length == 1) {
          this.dzo = this.selectedDzoOptions[0].value
          NProgress.start();

          let payload = {
            dzo_id: this.dzo,
            year: this.year,
            month: this.month || this.quarter,
          }

          axios
              .post('/tmz/summary-table/', payload)
              .then(response => {
                console.log(response.data);
                let dataObject = response.data;
                let newArr = Object.entries(dataObject)
                    .filter(item => item[0].length > 3)
                    .map(item => item[1].total_sum);
                console.info(newArr);
                this.tableData = newArr;
              })
              .then(response => {
                store.dispatch('addNotification', {
                  type: 'success',
                  message: 'Таблица обновлена',
                });
                NProgress.done();
              })
              .catch(error => {
                store.dispatch('addNotification', {
                  type: 'error',
                  message: error.response.data,
                });
                NProgress.done();
              });
        } else {
          NProgress.start();
          let selectedDzoIds = this.selectedDzoOptions.map(item => item.value)
          // console.log(selectedDzoIds)
          axios
              .post('/tmz/summary-table/', {
                dzo_id: selectedDzoIds,
                year: this.year,
                month: this.month || this.quarter,
              })
              .then(response => {
                console.log(response.data);
                let dataObject = response.data;
                let newArr = Object.entries(dataObject)
                    .filter(item => item[0].length > 3)
                    .map(item => item[1].total_sum);
                console.info(newArr);
                this.tableData = newArr;
              })
              .then(response => {
                store.dispatch('addNotification', {
                  type: 'success',
                  message: 'Таблица обновлена',
                });
                NProgress.done();
              })
              .catch(error => {
                store.dispatch('addNotification', {
                  type: 'error',
                  message: error.response.data,
                });
                NProgress.done();
              });
        }

      } else {
        this.dzo = this.USER.ouser.kmg_dzo.id
        NProgress.start();

        let payload = {
          dzo_id: this.dzo,
          year: this.year,
          month: this.month || this.quarter,
        }

        axios
            .post('/tmz/summary-table/', payload)
            .then(response => {
              console.log(response.data);
              let dataObject = response.data;
              let newArr = Object.entries(dataObject)
                  .filter(item => item[0].length > 3)
                  .map(item => item[1].total_sum);
              console.info(newArr);
              this.tableData = newArr;
            })
            .then(response => {
              store.dispatch('addNotification', {
                type: 'success',
                message: 'Таблица обновлена',
              });
              NProgress.done();
            })
            .catch(error => {
              store.dispatch('addNotification', {
                type: 'error',
                message: error.response.data,
              });
              NProgress.done();
            });
      }

      this.getTurnoverInfo()

    },
    getTurnoverInfo() {
      this.isLoading = true
      if (this.selectedDzoOptions.length == 0) {
        console.log('hehe')
        axios.post('tmz/turnover-summary/', {
          "dzo_id": '' + this.dzo,
          "month": this.month || this.quarter,
          "year": this.year
        }).then((response) => {
          this.turnoverDays = response.data.t_turnover_day
          this.isLoading = false
        })
      } else {
        console.log('nana')
        let selectedDzoIds = this.selectedDzoOptions.map(item => item.value)
        axios.post('tmz/turnover-summary/', {
          "dzo_id": selectedDzoIds,
          "month": this.month || this.quarter,
          "year": this.year
        }).then((response) => {
          this.turnoverDays = response.data.t_turnover_day
          this.isLoading = false
        })
      }

    },
    onSelect(selectedDzoOptions) {
      this.showSelectedDzo = true
      if (this.selectedDzoOptions.length < 3) {
        this.selectedDzoOptions = selectedDzoOptions
      } else {
        this.$store.dispatch("addNotification", {
          type: "error",
          message: 'Нельзя выбрать больше трех ДЗО',
        });
      }
    },
    clear() {
      this.dzo = ''
      this.year = ''
      this.month = ''
      this.quarter = ''
      this.selectedDzoOptions = []
      this.showSelectedDzo = false
    },
    download() {
      let selectedOptions = this.selectedDzoOptions.map(i => {
        return i.value
      })

      if (selectedOptions.length == 0) {
        selectedOptions[0] = this.USER.ouser.kmg_dzo.id
        axios
            .get('/tmz/download-summary-table/', {
              params: {
                dzoOptions: selectedOptions,
                year: this.year,
                month: this.month || this.quarter,
                turnover_summary: this.turnoverDays,
              },
              responseType: 'blob',
            }).then((response) => {
          const url = URL.createObjectURL(
              new Blob([response.data], {
                type: 'application/vnd.ms-excel',
              })
          )
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'Итоговая форма.xlsx')
          document.body.appendChild(link)
          link.click()
        })
      } else {
          axios
            .get('/tmz/download-summary-table/', {
              params: {
                dzoOptions: selectedOptions,
                year: this.year,
                month: this.month || this.quarter,
                turnover_summary: this.turnoverDays,
              },
              responseType: 'blob',
            }).then((response) => {
          const url = URL.createObjectURL(
              new Blob([response.data], {
                type: 'application/vnd.ms-excel',
              })
          )
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'Итоговая форма.xlsx')
          document.body.appendChild(link)
          link.click()
        })
      }
    },
    accessLevel(roles, level) {
      if (roles) {
        let arr = Object.keys(
            JSON.parse(JSON.stringify(this.USER.ouser.role))
        );
        for (const role in arr) {
          if (roles[role].access_level === level) {
            return true;
          }
        }
        return false;
      }
      return false;
    },
  },
  computed: {
    ...mapGetters(['dzoList', 'USER']),
    quarterPresent() {
      return this.quarter !== null && this.quarter !== undefined && this.quarter !== '';
    },
    monthPresent() {
      return this.month !== null && this.month !== undefined && this.month !== '';
    },
  },
};
</script>

<style lang="scss" scoped>
// TODO: Style should be deleted after moving all pages to TailwindCSS
.container {
  padding: 0;
}

/* Tooltip container */
.tooltip {
  position: relative;
  display: inline-block;
  cursor: help;
  //border-bottom: 1px dotted black; /* If you want dots under the hoverable text */
}

/* Tooltip text */
.tooltip .tooltiptext {
  visibility: hidden;
  width: 242px;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1;
  bottom: -140px;
  right: -117px;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
  visibility: visible;
}

button:disabled {
  background: #333;
}
</style>
